export default __webpack_public_path__ + "static/media/money-bag.34aa36d5.svg";